import http from 'infra/http';
import { useQuery } from 'react-query';
import { MensagemLeituraResponse } from './../typings/index';
import { PaginateResult } from 'core/resources/types/shared';

function useMensagemLeituras({mensagemId, page, enabled}: {mensagemId: string, page: number, enabled?: boolean}) {
  return useQuery([`/v1/mensagem/${mensagemId}/leituras`, page], async () => {
    const {data} = await http.get<PaginateResult<MensagemLeituraResponse>>(`/v1/mensagem/${mensagemId}/leituras`, {
      params: {
        page,
        limit: 10,
      }
    });

    return data;
  }, {
    enabled,
    refetchInterval: 30 * 1000,
  });
}

export default useMensagemLeituras